/* globals console window */

// Translation utility function

// Initalize translations. Find the table, and warn if empty
console.log("Translations initializing");
import translations from "translations";

if (Object.keys(translations).length !== 0) {
  console.log(translations);
  audit();
} else {
  // If the translation table has no keys
  console.error("Failed to initialize translations; using empty fallback.");
}

/**
 * Translates a single string based on a global context translation table.
 * @param {string} sourceString - The string to be translated
 * @returns {string}
 */
export function trans(sourceString) {
  if (translations.hasOwnProperty(sourceString)) {
    // If a translation exists, just return it
    return translations[sourceString];
  } else {
    // If no translation exists, let the user know
    console.warn(`Requested translation for "${sourceString}", but no such translation is available in the translation table`);

    // Find a similar string except with different case
    for (const key in translations) {
      if (sourceString.toLowerCase() === key.toLowerCase() && window.locale !== "en_US") {
        console.warn(`... however a translation for "${key}" does exist. (Maybe a typo?)`);
      }
    }

    // Return original string untouched (on failure)
    return(sourceString);
  }
}

/**
 * Performs an audit of the translation table, checking that all translations
 * are okay and any other audits which could help development
 */
function audit() {
  for (const key in translations) {
    if (key === translations[key] && window.locale !== "en") {
      console.warn(`Translation audit warning: translation for "${key}" is identical to source and might not have been translated`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/common/translate.js